/*
 * @LastEditTime: 2022-06-30 11:31:00
 */
import React, { Component } from 'react';
import './index.less';
class Header extends Component {
    render() {
        return (
            <div className="evalution_header">
                <div className="header">
                    <div className="header_top">
                        <img className="header_logo" src='//pic1.58cdn.com.cn/nowater/cxnomark/n_v278deb038d6a34f27bd69a799a2e3235a.png' alt="" />
                        <i className="header_line"></i>
                        <div className="header_top-title">
                            在线测评
                        </div>
                        <div className="header_login" >
                            <a href="//talent.chinahr.com/" target="_blank" className="header_btn" rel="noreferrer">登录测评系统</a>
                        </div>
                    </div>
                    <div className="header_title">
                        在线人才测评 科学识别人才
                        <div className="header_title-lt">
                        </div>
                    </div>
                    <div></div>
                    <div className="header_subtitle">
                        中小企业测评专属解决方案
                        <div className="header_title-rb">
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;